export const APP_NAME = 'Ridexcity';

// Brand colours — keep in sync with mobile app
export const BRAND = {
  primary:      '#0A2540',
  primaryLight: '#1A3A5C',
  accent:       '#00C6FF',
  accentDark:   '#008FB3',
  bg:           '#F4F7FB',
  cardBorder:   '#E2E8F0',
  textPrimary:  '#0F172A',
  textSecondary:'#475569',
  grey:         '#94A3B8',
};

// Role constants
export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN:      'admin',
  MANAGER:    'manager',
  SUPPORT:    'support',
};

// KYC statuses
export const KYC_STATUS = {
  PENDING:  'pending',
  REVIEW:   'review',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};
